import React, { useEffect, useState } from 'react';
import Icon from './AppIcon';
import { FAQ_ITEMS } from '../data/faqItems';

const FaqAccordion = ({ items = FAQ_ITEMS }) => {
  const [openIds, setOpenIds] = useState(() => new Set());

  useEffect(() => {
    const applyHash = () => {
      const hash = window.location.hash.replace('#', '');
      if (!hash || hash === 'faq') return;
      if (!items.some((item) => item.id === hash)) return;
      setOpenIds((prev) => {
        const next = new Set(prev);
        next.add(hash);
        return next;
      });
      requestAnimationFrame(() => {
        document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    };

    applyHash();
    window.addEventListener('hashchange', applyHash);
    return () => window.removeEventListener('hashchange', applyHash);
  }, [items]);

  const toggle = (id) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return (
    <div className="space-y-3">
      {items.map((item) => {
        const isOpen = openIds.has(item.id);
        const panelId = `faq-panel-${item.id}`;

        return (
          <div
            key={item.id}
            id={item.id}
            className="marketing-card overflow-hidden scroll-mt-24"
          >
            <button
              type="button"
              id={`faq-heading-${item.id}`}
              onClick={() => toggle(item.id)}
              aria-expanded={isOpen}
              aria-controls={panelId}
              className="w-full flex items-center gap-3 px-5 py-4 text-left min-h-[48px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-300 focus-visible:ring-inset"
            >
              <span className="flex-1 text-base font-semibold text-white">{item.question}</span>
              <span
                className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-transform duration-200 ${
                  isOpen ? 'rotate-180' : ''
                }`}
                style={{ background: 'rgba(34, 211, 238, 0.12)' }}
              >
                <Icon name="ChevronDown" size={16} color="#67E8F9" />
              </span>
            </button>
            {isOpen && (
              <div
                id={panelId}
                role="region"
                aria-labelledby={`faq-heading-${item.id}`}
                className="px-5 pb-5 pt-3 border-t border-cyan-300/10"
              >
                {item.answer.map((paragraph, index) => (
                  <p
                    key={index}
                    className={`marketing-muted text-sm leading-relaxed ${index > 0 ? 'mt-3' : ''}`}
                  >
                    {typeof paragraph === 'string'
                      ? paragraph
                      : paragraph.map((part, partIndex) =>
                          part.type === 'link' ? (
                            <a
                              key={partIndex}
                              href={part.href}
                              className="marketing-link"
                            >
                              {part.text}
                            </a>
                          ) : (
                            <span key={partIndex}>{part.text}</span>
                          )
                        )}
                  </p>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default FaqAccordion;
